import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import { STATUSES } from '@/const/status'

export default {
  namespaced: true,
  state: {
    admissionThresholdScores: [],
    totalRows: 0,
    statuses: STATUSES,
  },
  getters: {
    admissionThresholdScores: state => state.admissionThresholdScores,
    totalRows: state => state.totalRows,
    statuses: state => state.statuses,
  },
  mutations: {
    SET_ADMISSION_THRESHOLD_SCORES: (state, { total, records }) => {
      state.totalRows = total
      state.admissionThresholdScores = records
    },
  },
  actions: {
    async readAdmissionThresholdScores({ commit }, params) {
      try {
        const response = await axios.get('/admissions/admission_threshold_score', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { total, records } = data.data
          commit('SET_ADMISSION_THRESHOLD_SCORES', { total, records })
        }
      } catch (e) {
        handleCatch(e)
      }
    },
    async createAdmissionThresholdScores({ commit }, params) {
      try {
        const response = await axios.post('/admissions/admission_threshold_score', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async updateAdmissionThresholdScores({ commit }, params) {
      try {
        const response = await axios.put(`/admissions/admission_threshold_score/${params.id}`, params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async deleteAdmissionThresholdScores({ commit }, id) {
      try {
        const response = await axios.delete(`/admissions/admission_threshold_score/${id}`)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
